import { Injectable, Injector } from '@angular/core';
import { PageComponent } from '@icc/shared/helpers';
import { ActiveConfiguration } from '../configuration/active-configuration';
import { ComponentType } from '@angular/cdk/portal';
import { ConfiguratorOptions } from '@icc/shared/types';
import { IccConfiguratorData, IccPricesData } from '@icc/shared/data-types';
import { SubStep } from './step';
export interface StepIcon {
    fontSet?: string,
    fontIcon?: string,
    ligature?: string,
    svgIcon?: string,
}

export type StepComponentType = ComponentType<StepComponent> & {
    stepName: string | ((options?: ConfiguratorOptions) => string);
    stepIcon: StepIcon;
    dynamicStepTitle: boolean;
    stepEnable: (conf: ActiveConfiguration, options: ConfiguratorOptions, data: IccConfiguratorData & IccPricesData) => boolean;
    getListOfSubSteps: (conf: ActiveConfiguration, options: ConfiguratorOptions, data: IccConfiguratorData & IccPricesData, injector: Injector) => SubStep[];
};

@Injectable()
export abstract class StepComponent extends PageComponent {

    public static stepIcon: StepIcon = {
        ligature: 'apps'
    };
    public static stepName: string | ((options?: ConfiguratorOptions) => string) = '';
    public abstract configurator: string;
    public abstract stepId: string;
    public static dynamicStepTitle: boolean = false;
    public static stepEnable: (conf: ActiveConfiguration, options: ConfiguratorOptions, data: IccConfiguratorData & IccPricesData) => boolean = (conf, options, data) => true;
    public static getListOfSubSteps: (conf: ActiveConfiguration, options: ConfiguratorOptions, data: IccConfiguratorData & IccPricesData, injector: Injector) => SubStep[] = (conf, options, data, injector) => [];

    constructor() {
        super();
    }
}
